import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import OutletSection from "./components/OutletSection";
import NewEquipmentSection from "./components/NewEquipmentSection";
import TechServiceSection from "./components/TechServiceSection";
import Printing3DSection from "./components/Printing3DSection";
import RecordingStudioSection from "./components/RecordingStudioSection";
import WebServicesSection from "./components/WebServicesSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Terminos from "./components/Terminos";
import Privacidad from "./components/Privacidad";

function MainSite() {
  const [activeTab, setActiveTab] = useState('home');

  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return <Hero setActiveTab={setActiveTab} />;
      case 'outlet':
        return <OutletSection />;
      case 'equipos':
        return <NewEquipmentSection />;
      case 'servicio':
        return <TechServiceSection />;
      case 'impresion3d':
        return <Printing3DSection />;
      case 'estudio':
        return <RecordingStudioSection />;
      case 'web':
        return <WebServicesSection />;
      case 'contacto':
        return <ContactSection />;
      default:
        return <Hero setActiveTab={setActiveTab} />;
    }
  };

  return (
    <>
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />
      <main>
        {renderContent()}
      </main>
      <Footer setActiveTab={setActiveTab} />
      <WhatsAppButton />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-black">
      <Toaster 
        position="top-center" 
        richColors 
        toastOptions={{
          style: {
            background: '#1a1a1a',
            border: '1px solid rgba(139, 92, 246, 0.3)',
            color: '#fff'
          }
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainSite />} />
          <Route path="/terminos" element={<Terminos />} />
          <Route path="/privacidad" element={<Privacidad />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
